import { PUT_ENTERPRISES_ERROR, PUT_ENTERPRISES_START, PUT_ENTERPRISES_SUCCESS } from '../../types';

export default function put_enterprises(state, action) {
  switch (action.type) {
    case PUT_ENTERPRISES_START:
      return { ...state };
    case PUT_ENTERPRISES_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case PUT_ENTERPRISES_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}